import React, { Component } from 'react';
import MainDrawer from './InternalNavigation/drawer';
import InternalNavigation from './InternalNavigation';
import IndexHeaders from './Inventory/IndexHeaders';
import IndexTabs from './Inventory/IndexTabs';
import InventoryTable from './Inventory/InventoryTable';
import { NewButton } from './shared/NewButton'
import { BottomRow } from './shared/BottomRow'
import { actions as kegSizeActions } from './sagas/keg_sizes'
import { selectors as kegSizeSelectors } from './sagas/keg_sizes'
import { actions as inventoryActions } from './sagas/inventory'
import { selectors as inventorySelectors } from './sagas/inventory'
import ReactDOM from 'react-dom'
import { ScrollSync } from 'react-scroll-sync'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import NoFutureInventory from './Inventory/NoInventory'
import _ from 'lodash'

class Inventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer: false,
    };
    this.props.actions.kegSizeActions.getKegSizes()
    this.props.actions.inventoryActions.getInventory()
    this.toggleStock = this.props.actions.inventoryActions.toggleStock.bind(this)
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  toggleTabs = () => {
    this.toggleStock()
  }

  anyInventory = (products) => {
    return products.map( product => {
      return product
        && product.attributes
        && product.attributes.checkedinCount
        && this.anyFutureInventory(product) || this.anyAvailableInventory(product)
    }).includes(true)
  }

  anyFutureInventory = (product) => {
    return Object.values(product.attributes.futureInventoryCount).map( count => {
          return count === 0
        }).includes(false)
  }

  anyAvailableInventory = (product) => {
    return Object.values(product.attributes.availableInventoryCount).map( count => {
          return count === 0
        }).includes(false)
  }

  render () {
    return (
      <div>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <InternalNavigation
          toggleDrawer={this.toggleDrawer}/>
        <div className='inventories'>
          <div className='inventories-title'>
            <div className='page-title'>
              Inventory
            </div>
          </div>
          { this.props.loaded && this.props.products && !this.anyInventory(this.props.products) &&
            <NoFutureInventory />
          }
          { this.props.loaded && this.props.products && this.anyInventory(this.props.products) &&
            <div>
              <ScrollSync>
                <div>
                  <IndexTabs
                    stocked={ this.props.stocked }
                    toggleTabs={ this.toggleStock }/>
                  <IndexHeaders
                    kegSizes={ this.props.kegSizes } />
                  <InventoryTable
                    kegSizes={ this.props.kegSizes }
                    stocked={ this.props.stocked } />
                </div>
              </ScrollSync>
              <BottomRow widthClass={'bottom-row-9'} />
            </div>
          }
        </div>
      </div>
    );
  }

};

const mapStateToProps = (store) => ({
  kegSizes: kegSizeSelectors.kegSizes(store),
  stocked: inventorySelectors.stocked(store),
  products: inventorySelectors.products(store),
  loaded: inventorySelectors.loaded(store)
})

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      kegSizeActions: bindActionCreators(kegSizeActions, dispatch),
      inventoryActions: bindActionCreators(inventoryActions, dispatch)
    }
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(Inventory))



// WEBPACK FOOTER //
// ./src/Inventory.js